import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import {
  IMAGE_SRC,
  STATUS_OPTIONS,
} from 'src/app/components/shared/shared-constants';
import {
  HEADER_VALUES,
  OFFSET_OPTIONS,
  ROW_VALUES,
} from './default-sort-schedule-setting.constants';
import { TableCell } from './default-sort-schedule-setting.model';

@Component({
  selector: 'app-default-sort-schedule-setting',
  templateUrl: './default-sort-schedule-setting.component.html',
  styleUrls: ['./default-sort-schedule-setting.component.scss'],
  standalone: false,
})
export class DefaultSortScheduleSettingComponent implements OnInit {
  readonly IMAGES = IMAGE_SRC;
  TABLE_DATA = ROW_VALUES;
  readonly HEADERS = HEADER_VALUES;
  readonly IMAGE_OPTIONS = STATUS_OPTIONS;
  readonly OFFSET_OPTIONS = OFFSET_OPTIONS;

  @Input() form!: FormGroup;

  form1: FormGroup = new FormGroup({});
  originalRowValues: { [key: string]: string } = {};

  ngOnInit() {
    if (this.form instanceof FormArray) {
      const formArray = this.form;
      this.initializeFormControlsFromFormArray(formArray);
      this.TABLE_DATA = this.generateRowValuesFromFormArray(formArray);
    } else {
      console.error('Expected FormArray but got:', this.form);
    }
  }

  getFormControl(name: string | null | undefined): FormControl {
    if (!name || typeof name !== 'string') {
      throw new Error('Invalid form control name');
    }

    let control = this.form1.get(name);
    if (!control) {
      this.form1.addControl(name, new FormControl(''));
      control = this.form1.get(name);
    }

    return control as FormControl;
  }

  initializeFormControlsFromFormArray(formArray: FormArray): void {
    const dayKeys = ['sun', 'mon', 'tue', 'wed', 'thr', 'fri', 'sat'];

    for (const group of formArray.controls) {
      const sortType = group.get('sortType')?.value;

      for (const day of dayKeys) {
        const dayGroup = group.get(day) as FormGroup;
        const dayShort = day.charAt(0).toUpperCase() + day.slice(1);

        this.form1.addControl(
          `${sortType}${dayShort}Start`,
          new FormControl(dayGroup.get('startTime')?.value),
        );
        this.form1.addControl(
          `${sortType}${dayShort}End`,
          new FormControl(dayGroup.get('endTime')?.value),
        );
        this.form1.addControl(
          `${sortType}${dayShort}Offset`,
          new FormControl(dayGroup.get('offset')?.value),
        );
      }
    }
  }

  generateRowValuesFromFormArray(formArray: FormArray): TableCell[][] {
    const dayMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'];

    return formArray.controls.map((group: AbstractControl) => {
      const sortType = group.get('sortType')?.value;

      const labelCell: TableCell = {
        label: sortType,
        formControl: null,
        formControlStart: null,
        formControlEnd: null,
        formControlOffset: null,
      };

      const dayCells: TableCell[] = dayMap.map((day) => ({
        label: null,
        formControl: null,
        formControlStart: `${sortType}${day}Start`,
        formControlEnd: `${sortType}${day}End`,
        formControlOffset: `${sortType}${day}Offset`,
      }));

      return [labelCell, ...dayCells];
    });
  }

  onCheckboxToggle(isChecked: boolean, row: any[]): void {
    for (const cell of row) {
      [
        'formControl',
        'formControlStart',
        'formControlEnd',
        'formControlOffset',
      ].forEach((key) => {
        const controlName = cell[key];
        if (controlName) {
          const control = this.form1.get(controlName);
          if (control) {
            if (!this.originalRowValues[controlName]) {
              this.originalRowValues[controlName] = control.value;
            }

            control.setValue(
              isChecked ? '0' : this.originalRowValues[controlName],
            );
          }
        }
      });
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    const allowedChars = /[0-9:]/;
    const inputChar = event.key;
    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }
}
